import { Results as CommonResult } from '../common'

export const Results = () => <CommonResult displayMode />